import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

// Check "que se dibuja" (referencia react-hot-toast): círculo verde que hace pop con
// overshoot y una "L" de bordes blancos que crece en dos tiempos. Solo transform/opacity.
const circleIn = keyframes`
  from { transform: scale(0) rotate(45deg); opacity: 0; }
  to { transform: scale(1) rotate(45deg); opacity: 1; }
`;

const checkDraw = keyframes`
  0% { height: 0; width: 0; opacity: 0; }
  40% { height: 0; width: 6px; opacity: 1; }
  100% { height: 10px; width: 6px; opacity: 1; }
`;

function AnimatedCheckIcon() {
  return (
    <Box
      aria-hidden
      sx={{
        width: 20,
        height: 20,
        flex: 'none',
        borderRadius: '10px',
        bgcolor: 'toast.success',
        opacity: 0,
        transform: 'scale(0) rotate(45deg)',
        animation: `${circleIn} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
        animationDelay: '100ms',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '6px',
          left: '6px',
          width: 6,
          height: 10,
          boxSizing: 'border-box',
          borderRight: '2px solid #FFFFFF',
          borderBottom: '2px solid #FFFFFF',
          opacity: 0,
          animation: `${checkDraw} 0.2s ease-out forwards`,
          animationDelay: '200ms'
        }
      }}
    />
  );
}

export default AnimatedCheckIcon;
